/**
 * Route guard for the booking funnel. Redirects to an earlier step (default
 * /bookingflight) if the data a step depends on is missing — so deep-linking straight
 * to /bookingflight/payment without a selected flight can't render a broken page.
 *
 * Usage:
 *   <RequireBookingStep needs={['searchCriteria', 'selectedFlight']}>
 *     <ReviewBooking />
 *   </RequireBookingStep>
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useBooking } from "../../context/BookingContext";

/**
 * @param {Object} props
 * @param {Array<'searchCriteria'|'selectedFlight'|'passengers'|'contact'|'fare'|'confirmation'>} props.needs
 * @param {string} [props.redirectTo]
 * @param {React.ReactNode} props.children
 */
export default function RequireBookingStep({
  needs = [],
  redirectTo = "/bookingflight",
  children,
}) {
  const booking = useBooking();

  const missing = needs.some((key) => {
    const value = booking[key];
    if (Array.isArray(value)) return value.length === 0;
    return value === null || value === undefined;
  });

  if (missing) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
